import { useEffect, useState } from 'react'

const useClientSide = (clientValue: string, serverReturn = ''): string => {
  const [isClientSide, setClientSide] = useState(false)
  useEffect(() => {
    setClientSide(true)
  }, [])
  if (isClientSide) return clientValue
  return serverReturn
}

export default useClientSide
